<template>
  <div>
    <section class="bg-white py-8 border-b-2 border-gray-300">
      <div class="w-full md:w-10/12 mx-auto flex justify-between px-4 md:px-0">
        <div class="flex w-full md:w-2/3 lg:w-1/2 flex-col justify-center items-start">
          <h2 class="font-bold text-2xl">Assigning Payment Details</h2>
          <h3
            class="text-xl text-gray-600 mr-5 mt-5"
          >Please wait while we assign the payment details to your account.</h3>
        </div>
        <span class="mdi mdi-loading mdi-spin text-5xl text-gray-500"></span>
      </div>
    </section>
  </div>
</template>

<style scoped>
</style>

<script>
import axios from "axios";

export default {
  mounted() {
    this.$nextTick(async () => {
      let sessionId = this.$authService._getParameterByName("session_id");
      if (sessionId) {
        try {
          await axios.put("/api/complete-profile/completed-setup");
          await this.$store.dispatch("getUserProfile");
          this.$router.push("/");
        } catch (error) {
          console.error(error);
        }
      }
    });
  }
};
</script>